import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { SketchPicker } from 'react-color';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const ListaTL = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoLub" id="miLista8" value={permiteUpdate?argsDocum.tipoLub:idLista.tipoLub} onChange={(ev)=>handleChange(ev)}>
        <option>Aceite</option>
        <option>Grasa</option>
        <option>Otro</option>
      </select>
    </div>
  )
};

const ListaTG = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoGrado" id="miLista1" value={permiteUpdate?argsDocum.tipoGrado:idLista.tipoGrado} onChange={(ev)=>handleChange(ev)}>
        <option>ISO</option>
        <option>SAE</option>
        <option>NLGI</option>
      </select>
    </div>
  )
};

const ListaCT = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="colorTexto" id="miLista2" value={permiteUpdate?argsDocum.colorTexto:idLista.colorTexto} onChange={(ev)=>handleChange(ev)}>
        <option>BLANCO</option>
        <option>NEGRO</option>
      </select>
    </div>
  )
};

const ListaS = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="sector" id="miLista5" value={permiteUpdate?argsDocum.sector:idLista.sector} onChange={(ev)=>handleChange(ev)}>
        <option>AUTOMOTRIZ</option>
        <option>INDUSTRIAL</option>
      </select>
    </div>
  )
};

const ListaA = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="aplicacionSAE" id="miLista6" value={permiteUpdate?argsDocum.aplicacionSAE:idLista.aplicacionSAE} onChange={(ev)=>handleChange(ev)}>
        <option>ENGRANAJES AUTOMOTRICES</option>
        <option>MOTORES COMBUSTION INTERNA</option>
      </select>
    </div>
  )
};

const ListaC = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="categoriaSAE" id="miLista3" value={permiteUpdate?argsDocum.categoriaSAE:idLista.categoriaSAE} onChange={(ev)=>handleChange(ev)}>
        <option>MONOGRADO</option>
        <option>MULTIGRADO</option>
      </select>
    </div>
  )
};

const ListaApi = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="apiSAE" id="miLista4" value={permiteUpdate?argsDocum.apiSAE:idLista.apiSAE} onChange={(ev)=>handleChange(ev)}>
        <option>S</option>
        <option>C</option>
        <option>G</option>
        <option>SL</option>
        <option>SM</option>
        <option>SN</option> 
        <option>CH-4</option>
        <option>CI-4</option>
        <option>CJ-4</option> 
        <option>CK-4</option>
        <option>FA-4</option>
        <option>FB</option>   
        <option>FC</option>   
        <option>FD</option>   
        <option>TC-W1</option>   
        <option>TC-W2</option>   
        <option>TC-W3</option>
        <option>MA</option>   
        <option>MA-1</option>   
        <option>MA-2</option>    
        <option>MB</option>    
      </select>
    </div>
  )
};
const ListaApi2 = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="apiSAE2" id="miLista7" value={permiteUpdate?argsDocum.apiSAE:idLista.apiSAE} onChange={(ev)=>handleChange(ev)}>
        <option>S</option>
        <option>C</option>
        <option>G</option>
        <option>GL-4</option>
        <option>GL-5</option>
        <option>MT-1</option>  
        <option>MIL-PRF-2105E</option>  
        <option>SAE J 2360</option>  
        <option>Dexron IV</option>
        <option>Mercon V</option>   
        <option>C-A</option>   
        <option>World Spec</option>    
        <option>Volth</option>          
      </select>
    </div>
  )
};

class VerGrado2 extends React.Component {
  state={
    argsDocum: {
      tipoLub: this.props.idLista.tipoLub,
      tipoGrado: this.props.idLista.tipoGrado,
      descrGrado: this.props.idLista.descrGrado,
      sector: this.props.idLista.sector?this.props.idLista.sector:'AUTOMOTRIZ',
      aplicacionSAE: this.props.idLista.aplicacionSAE?this.props.idLista.aplicacionSAE:'ENGRANAJES AUTOMOTRICES',
      categoriaSAE: this.props.idLista.categoriaSAE?this.props.idLista.categoriaSAE:'MONOGRADO',
      apiSAE: this.props.idLista.apiSAE?this.props.idLista.apiSAE:'S',
      color: this.props.idLista.color,
      colorTexto: this.props.idLista.colorTexto,
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  // handleChangeComplete = (color) => {
  //   this.setState({ background: color.hex });
  // };

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      // if(ev.target.name === "tipoLub"){
      //   console.log(ev.target.name, ev.target.value)
      //   let miLista = document.getElementById("miLista");
      //   argsDocum['tipoLub'] = miLista.options[miLista.selectedIndex].text
      // }else{
      //   console.log(ev.target.name, ev.target.value)
      if (ev.target.name==='apiSAE2'){
        argsDocum['apiSAE'] = ev.target.value
      }else{
          argsDocum[ev.target.name] = ev.target.value
      }
          // }
      this.setState({argsDocum});
    }
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  handleChangeColor = (color) => {
    const argsDocum = this.state.argsDocum
    argsDocum['color'] = color.hex
    this.setState({argsDocum});
  };  

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    let tipoGradoAnt = this.props.idLista.tipoGrado
    let descrGradoAnt = this.props.idLista.descrGrado    
    let apiSAEAnt = this.props.idLista.apiSAE    
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Grados
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, tipoGradoAnt, descrGradoAnt, apiSAEAnt):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de lubricante</label>
                    <ListaTL styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de grado</label>
                    <ListaTG styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrGrado" id="descrGrado" value={this.props.permiteUpdate?argsDocum.descrGrado:this.props.idLista.descrGrado} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrGrado'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>                  
                  {argsDocum.tipoLub==='Aceite' &&
                  <div>
                    <Form.Field>
                      <label style={this.props.styles.label}>Sector</label>
                      <ListaS styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                    {argsDocum.sector==='AUTOMOTRIZ' &&
                    <div>                    
                      <Form.Field>
                        <label style={this.props.styles.label}>Aplicación SAE</label>
                        <ListaA styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                      <Form.Field>
                        <label style={this.props.styles.label}>Categoría SAE</label>
                        <ListaC styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                      {argsDocum.aplicacionSAE==='MOTORES COMBUSTION INTERNA' &&
                      <div>
                        <Form.Field>
                          <label style={this.props.styles.label}>Api SAE</label>
                          <ListaApi styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      }
                      {argsDocum.aplicacionSAE==='ENGRANAJES AUTOMOTRICES' &&
                      <div>
                        <Form.Field>
                          <label style={this.props.styles.label}>Api SAE</label>
                          <ListaApi2 styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      }                    
                    </div>
                    }
                  </div>
                  }
                  <Form.Field>
                  <label style={this.props.styles.label}>Color</label>
                  <SketchPicker
                    color={argsDocum.color}
                    onChangeComplete={this.handleChangeColor}
                  />                                                                
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Color de texto</label>
                    <ListaCT styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerGrado2
